import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { toast } from 'sonner';

const API = window.location.origin;

const ChatNotificationToggle = () => {
  const [enabled, setEnabled] = useState(true);
  const [loading, setLoading] = useState(true);
  const [updating, setUpdating] = useState(false);

  useEffect(() => {
    loadSettings();
  }, []);

  const loadSettings = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem('token') || localStorage.getItem('access_token');
      const response = await axios.get(`${API}/api/chat/notifications/settings`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      
      setEnabled(response.data.enabled);
    } catch (error) {
      console.error('Error loading chat notification settings:', error);
      toast.error('Error al cargar configuración de notificaciones de chat');
    } finally {
      setLoading(false);
    }
  };

  const handleToggle = async () => {
    try {
      setUpdating(true);
      const newValue = !enabled;
      const token = localStorage.getItem('token') || localStorage.getItem('access_token');
      
      await axios.post(
        `${API}/api/chat/notifications/settings?enabled=${newValue}`,
        {},
        { headers: { Authorization: `Bearer ${token}` } }
      );
      
      setEnabled(newValue);
      toast.success(
        newValue 
          ? '✅ Notificaciones de chat activadas' 
          : '🔕 Notificaciones de chat desactivadas'
      );
    } catch (error) {
      console.error('Error updating chat notification settings:', error);
      toast.error('Error al actualizar configuración');
    } finally {
      setUpdating(false);
    }
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center p-4">
        <i className="fas fa-spinner fa-spin text-blue-600 mr-2"></i>
        <span className="text-gray-600">Cargando...</span>
      </div>
    );
  }

  return (
    <div className="flex items-center justify-between p-4 bg-white rounded-lg border border-gray-200">
      <div className="flex items-center space-x-4">
        <div className={`p-3 rounded-lg ${enabled ? 'bg-green-100' : 'bg-gray-100'}`}>
          <i className={`fas fa-bell text-2xl ${enabled ? 'text-green-600' : 'text-gray-400'}`}></i>
        </div>
        <div>
          <h3 className="font-medium text-gray-900">
            Notificaciones Push de Chat
          </h3>
          <p className="text-sm text-gray-600">
            {enabled 
              ? 'Recibirás notificaciones cuando te envíen mensajes' 
              : 'No recibirás notificaciones de mensajes nuevos'}
          </p>
        </div>
      </div>
      
      <button
        onClick={handleToggle}
        disabled={updating}
        className={`relative inline-flex items-center h-6 rounded-full w-11 transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 ${
          enabled ? 'bg-green-600' : 'bg-gray-300'
        } ${updating ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`}
      >
        <span
          className={`inline-block w-4 h-4 transform bg-white rounded-full transition-transform ${
            enabled ? 'translate-x-6' : 'translate-x-1'
          }`}
        />
      </button>
    </div>
  );
};

export default ChatNotificationToggle;
